import * as React from 'react';
import { clsx } from 'clsx';
import { IconLoader } from 'icons';

interface Props {
  isLoading?: boolean;
  initialLoad?: boolean;
}

export default function Loader({ isLoading = true, initialLoad }: Props) {
  if (!isLoading) return null;

  return (
    <div
      className={clsx('p-2 text-grey5', { 'pt-8': initialLoad })}
      aria-busy="true"
      aria-live="polite"
    >
      <IconLoader className="mx-auto w-6 h-6" />
    </div>
  );
}
